import defaultComics from "../data/comics.json";

const COMICS_KEY = "comics";

export function initializeComics() {
  if (!localStorage.getItem(COMICS_KEY)) {
    localStorage.setItem(COMICS_KEY, JSON.stringify(defaultComics));
  }
}

export function getAllComics() {
  initializeComics();
  return JSON.parse(localStorage.getItem(COMICS_KEY));
}

export function getComicById(id) {
  initializeComics();
  return JSON.parse(localStorage.getItem(COMICS_KEY)).find((c) => c.id === id);
}

export function addComic(newComic) {
  initializeComics();
  const comics = JSON.parse(localStorage.getItem(COMICS_KEY));
  comics.push(newComic);
  localStorage.setItem(COMICS_KEY, JSON.stringify(comics));
}

export function deleteComic(id) {
  initializeComics();
  const comics = JSON.parse(localStorage.getItem(COMICS_KEY)).filter((c) => c.id !== id);
  localStorage.setItem(COMICS_KEY, JSON.stringify(comics));
  return comics;
}
